import axios from 'axios';

const PORTAL_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthUser {
  id: number;
  email: string;
  otherNames: string;
  lastName: string;
  fullName: string;
  roleId: number;
  roleName: string;
  dojoId: number | null;
  status: string;
}

export interface LoginResponse {
  token: string;
  user: AuthUser;
}

export const login = async (
  credentials: LoginCredentials
): Promise<LoginResponse> => {
  const response = await axios.post(
    `${PORTAL_API_URL}/auth/login`,
    credentials
  );

  const data = response.data;

  // Map portal API response to our AuthUser format
  const user: AuthUser = {
    id: data.user.id,
    email: data.user.email,
    otherNames: data.user.otherNames,
    lastName: data.user.lastName,
    fullName: data.user.fullName,
    roleId: data.user.role?.id,
    roleName: data.user.role?.name,
    dojoId: data.user.profiles?.[0]?.dojoId || null,
    status: data.user.isApproved ? 'active' : 'inactive',
  };

  return {
    token: data.accessToken,
    user,
  };
};

export const logout = (): void => {
  localStorage.removeItem('nask_token');
  localStorage.removeItem('nask_user');
};

export const getStoredUser = (): AuthUser | null => {
  const stored = localStorage.getItem('nask_user');
  return stored ? JSON.parse(stored) : null;
};

export const getStoredToken = (): string | null => {
  return localStorage.getItem('nask_token');
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('nask_token');
};